<!--
  @description: 无欠税证明
-->
<template>
  <!-- 纸张 -->
  <paper class="no-tax-debt-proof">
    <!-- 表格 -->
    <bms-pane
      ref="tablePage"
      :config="config"
      :totalData="totalData"
      :pageTotal="pageTotal"
      :loading="loading"
      :searchTotalTitle="config.searchTotalTitle"
      :currentPage="currentPage"
      searchId="noTaxDebtProof"
      pageID="_noTaxDebtProof"
      @row-db-click="handleRowDBClick"
      @cell-click="handleCellClick"
      @selectChange="handleSelectChange"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @sizeChange="handleSizeChange"
      @upload-btn="handleUploadBtn"
      @submit-btn="handleSubmitBtn"
      />
    <!-- 上传弹窗 -->
    <UploadMultipleDialog v-model="showUpload" @uploadConfirm="handleUploadConfirm" />
    <!-- 预览弹窗 -->
    <PreviewFilesDialog ref="previewFilesDialogRef" @delete="handleDeleteFile" />
  </paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import UploadMultipleDialog from '@/modules/transport/bms/components/upload/UploadMultipleDialog';
import PreviewFilesDialog from '@/modules/transport/bms/components/upload/PreviewFilesDialog';
import BmsPane from '@/modules/transport/bms/components/supplierPanel';
import mTableMixin from '@/modules/transport/bms/mixins/mTableMixin.js';
import config from './config.js';
import { querySupTask, fileUpload, submitTaskFlow, checkFileDel } from '@/modules/transport/bms/api/noTaxDebtProofApi.js';

export default {
    name: 'NoTaxDebtProof',
    mixins: [mTableMixin],
    components: { BmsPane, Paper, UploadMultipleDialog, PreviewFilesDialog },
    data() {
        return {
            config,
            // 上传弹窗
            showUpload: false,
            // 当前单据号
            curJobId: '',
            // 提交loading
            submitLoading: false,
            searchParams: {
                taskStatus: 'UN_SUBMIT'
            }
        };
    },
    activated() {
        if (this.$route.query.from === 'todoList') {
            this.handleTodo();
        }
    },
    methods: {
        // 查询
        queryListExecute({ params, successCallback }) {
            this.loading = true;
            querySupTask(params).then(res => {
                if (res && +res.code === 0) {
                    try {
                        res.data.list.forEach(item => {
                            item.fileList = item.fileList && item.fileList instanceof Array ? item.fileList : [];
                            item.attachment = item.fileList ? item.fileList.map(el => el.substr1).join(',') : '';
                            item.mipStatus = item.mipStatus + '';
                            item['submitDisabled'] = item.taskStatus !== 'UN_SUBMIT';
                            item['uploadDisabled'] = item.taskStatus !== 'UN_SUBMIT';
                            item.fileList.forEach(el => {
                                el['deleteDisabled'] = item.taskStatus !== 'UN_SUBMIT';
                            });
                        });
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.warn(e);
                    }
                    successCallback(res);
                }
            }).finally(() => { this.loading = false; });
        },
        // 扩展查询列表方法，支持回调
        queryList(options = {}) {
            const params = { pageNo: this.pageNo, pageSize: this.pageSize, ...this.searchParams };
            const successCallback = (res) => {
                const data = res.data || res || {};
                this.totalData = (Array.isArray(data) && data) || data.list || [];
                this.pageTotal = data.totalCount || 0;

                // 执行回调函数（如果有）
                if (options.callback && typeof options.callback === 'function') {
                    options.callback();
                }
            };
            this.queryListExecute({ params, successCallback });
        },
        // 上传按钮
        handleUploadBtn(row) {
            this.curJobId = row.jobId;
            this.showUpload = true;
        },
        // 处理提交按钮
        handleSubmitBtn(row) {
            const params = {
                jobId: row.jobId,
                certTaskNo: row.certTaskNo
            };

            this.$confirm('确认提交该任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        row.submitLoading = true;
                        row.uploadDisabled = true;
                        row.fileList.forEach(el => {
                            el['deleteDisabled'] = true;
                        });
                        let isSuccess = false;
                        submitTaskFlow(params).then(res => {
                            isSuccess = res && res.code === '0';
                        }).finally(() => {
                            setTimeout(() => {
                                isSuccess && this.$message.success('提交成功');
                                row.submitLoading = false;
                                row.uploadDisabled = false;
                                row.fileList.forEach(el => {
                                    el['deleteDisabled'] = false;
                                });
                                this.queryList();
                                done();
                                instance.confirmButtonLoading = false;
                            }, 1000);
                        });
                    } else {
                        done();
                    }
                }
            }).catch(() => {});
        },
        // 上传确认
        handleUploadConfirm(files) {
            let successCount = 0;
            let failCount = 0;
            const currentRow = this.totalData.find(item => item.jobId === this.curJobId);

            const uploadPromises = files.map((uploadData) => {
                const file = new File([uploadData.file], uploadData.file.name, {
                    type: uploadData.file.type
                });
                const formData = new FormData();
                formData.append('file', file);
                formData.append('businessId', this.curJobId);
                formData.append('moduleCode', 'EfNoOwetaxCertTaskELEditor');
                formData.append('systemSource', '10');

                return fileUpload(formData).then(res => {
                    if (res && res.code === '0') {
                        successCount++;
                    } else {
                        this.$message.error(res.message);
                        failCount++;
                    }
                }).catch(() => {
                    failCount++;
                });
            });

            Promise.all(uploadPromises)
                .then(() => {
                    if (failCount === 0) {
                        this.$message.success('所有文件上传成功');
                    } else {
                        this.$message.warning(`上传完成：成功${successCount}个，失败${failCount}个`);
                    }
                    // 刷新列表并在完成后询问是否提交
                    this.queryList({
                        callback: () => {
                            // 找到当前操作的记录
                            if (failCount === 0 && currentRow && currentRow.jobId === this.curJobId) {
                                // 检查单据状态是否是待提交
                                if (currentRow.taskStatus === 'UN_SUBMIT') {
                                    this.$confirm('上传完成，是否立即提交?', '提示', {
                                        confirmButtonText: '提交',
                                        cancelButtonText: '不提交',
                                        type: 'info'
                                    }).then(() => {
                                        // 调用提交方法
                                        this.handleSubmitBtn(currentRow);
                                    }).catch(() => {
                                        // 用户选择不提交，不执行任何操作
                                    });
                                }
                            }
                        }
                    });
                });
        },
        // 删除附件
        handleDeleteFile(file) {
            if (!file || !file.jobId) {
                this.$message.warning('无法获取附件ID，无法删除');
                return;
            }

            const data = {
                'taskId': this.curJobId,
                'fileIds': [file.jobId]
            };

            checkFileDel(data).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('删除成功');
                    // 不关闭预览弹窗，从文件列表中移除已删除的文件
                    const fileList = this.$refs.previewFilesDialogRef.fileList;
                    const index = fileList.findIndex(item => item.jobId === file.jobId);
                    if (index !== -1) {
                        fileList.splice(index, 1);
                    }
                    // 如果文件列表为空，则关闭预览弹窗
                    if (fileList.length === 0) {
                        this.$refs.previewFilesDialogRef.close();
                    }
                    // 刷新列表
                    this.queryList();
                } else {
                    this.$message.error(res.errMsg || '删除失败');
                }
            });
        },
        // 预览文件
        previewFiles(files) {
            this.$nextTick(() => {
                files && files.length && this.$refs.previewFilesDialogRef.open(files);
            });
        },
        // 单元格点击
        handleCellClick({ row, column }) {
            this.curJobId = row.jobId;
            if (column.property === 'attachment') {
                const fileList = row.fileList;
                this.previewFiles(fileList);
            }
        },
        // 首页跳转过来 参数处理
        handleTodo() {
            this.$set(this.searchParams, 'taskStatus', 'UN_SUBMIT');
            this.$nextTick(() => {
                this.$refs.tablePage.$refs.searchList.setQueryParams({ 'taskStatus': 'UN_SUBMIT' });
            });
            this.$router.replace({ query: {} });
        },
        initSearchParamsExecute(params) {
            if (this.$route.query.from === 'todoList') {
                this.handleTodo();
            }
            this.$nextTick(() => {
                this.$refs.tablePage.$refs.searchList.setQueryParams(this.searchParams);
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../../styles/common.less";
.no-tax-debt-proof {
  min-width: 1200px;
  margin: 7px;
  #mPane3 .el-table {
        min-height: calc(100vh - 204px);
    }
}
</style>
<style>
.el-tooltip__popper.is-dark{
    max-width: 700px !important;
}
</style>
